import { Component, Input, ElementRef, HostListener } from '@angular/core';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: '[sa-ellipsis]',
  templateUrl: './ellipsis.component.html',
  styleUrls: ['./ellipsis.component.scss'],
})
export class EllipsisComponent {
  @Input() placement = 'top';
  @Input() whiteSpace = 'pre-wrap';
  @Input() fullText: string;
  @Input() oneTime = true;
  @Input() tooltipText: string;

  public isTextTruncated = false;
  public tooltipDelay = 300;

  constructor(private elementRef: ElementRef) {}

  private get element(): HTMLElement {
    return this.elementRef.nativeElement;
  }

  @HostListener('mouseover') onMouseOver() {
    this.isTextTruncated = this.element.firstElementChild.scrollWidth > this.element.firstElementChild.clientWidth;
  }
}
